module.exports = __webpack_public_path__ + "static/media/borderbl.bd11bb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/borderbl.png
// module id = 455
// module chunks = 0